var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/shared/inversify/index.ts
var inversify_exports = {};
__reExport(inversify_exports, inversify_star);
import * as inversify_star from "inversify";

// src/common/contribution-provider.ts
var ContributionProvider = Symbol.for("ContributionProvider");
var ContainerBasedContributionProvider = class {
  constructor(serviceIdentifier, container) {
    this.serviceIdentifier = serviceIdentifier;
    this.container = container;
    __publicField(this, "services");
  }
  getContributions(recursive) {
    if (this.services === void 0) {
      const currentServices = [];
      let currentContainer = this.container;
      while (currentContainer !== null) {
        if (currentContainer.isBound(this.serviceIdentifier)) {
          try {
            currentServices.push(...currentContainer.getAll(this.serviceIdentifier));
          } catch (error) {
            console.error(error);
          }
        }
        currentContainer = recursive === true ? currentContainer.parent : null;
      }
      this.services = currentServices;
    }
    return this.services;
  }
};
var Bindable;
((Bindable2) => {
  function isContainer(arg) {
    return typeof arg !== "function" && ("guid" in arg || "parent" in arg);
  }
  Bindable2.isContainer = isContainer;
})(Bindable || (Bindable = {}));
function bindContributionProvider(bindable, id) {
  const bindingToSyntax = Bindable.isContainer(bindable) ? bindable.bind(ContributionProvider) : bindable(ContributionProvider);
  bindingToSyntax.toDynamicValue((ctx) => new ContainerBasedContributionProvider(id, ctx.container)).inSingletonScope().whenTargetNamed(id);
}

// src/common/disposable.ts
import _ from "lodash";
function isObject(value) {
  return typeof value === "object" && value !== null;
}
var Disposable;
((Disposable2) => {
  function is(arg) {
    return isObject(arg) && _.isFunction(arg.dispose);
  }
  Disposable2.is = is;
  function create2(func) {
    return { dispose: func };
  }
  Disposable2.create = create2;
})(Disposable || (Disposable = {}));
Object.defineProperty(Disposable, "NULL", {
  configurable: false,
  enumerable: true,
  get() {
    return { dispose: () => {
    } };
  }
});
function disposableTimeout(...args) {
  const handle = setTimeout(...args);
  return { dispose: () => clearTimeout(handle) };
}

// src/common/event.ts
var CallbackList = class {
  constructor() {
    __publicField(this, "_callbacks");
    __publicField(this, "_contexts");
  }
  get length() {
    return this._callbacks && this._callbacks.length || 0;
  }
  add(callback, context = void 0, bucket) {
    if (!this._callbacks) {
      this._callbacks = [];
      this._contexts = [];
    }
    this._callbacks.push(callback);
    this._contexts.push(context);
    if (Array.isArray(bucket)) {
      bucket.push({ dispose: () => this.remove(callback, context) });
    }
  }
  remove(callback, context = void 0) {
    if (!this._callbacks) {
      return;
    }
    let foundCallbackWithDifferentContext = false;
    for (let i = 0; i < this._callbacks.length; i++) {
      if (this._callbacks[i] === callback) {
        if (this._contexts[i] === context) {
          this._callbacks.splice(i, 1);
          this._contexts.splice(i, 1);
          return;
        } else {
          foundCallbackWithDifferentContext = true;
        }
      }
    }
    if (foundCallbackWithDifferentContext) {
      throw new Error("When adding a listener with a context, you should remove it with the same context");
    }
  }
  iterator() {
    if (!this._callbacks) {
      return [];
    }
    const callbacks = this._callbacks.slice(0);
    const contexts = this._contexts.slice(0);
    return callbacks.map(
      (callback, i) => (...args) => callback.apply(contexts[i], args)
    );
  }
  invoke(...args) {
    const ret = [];
    for (const callback of this.iterator()) {
      try {
        ret.push(callback(...args));
      } catch (e) {
        console.error(e);
      }
    }
    return ret;
  }
  isEmpty() {
    return !this._callbacks || this._callbacks.length === 0;
  }
  dispose() {
    this._callbacks = void 0;
    this._contexts = void 0;
  }
};
var _Emitter = class _Emitter {
  /**
   * Creates a new instance of the Emitter class.
   * @param _options Optional options for the emitter.
   */
  constructor(_options) {
    this._options = _options;
    __publicField(this, "_callbacks");
    __publicField(this, "_event");
    __publicField(this, "_disposed", false);
  }
  /**
   * Gets the event associated with the emitter.
   * @returns The event object.
   */
  get event() {
    if (!this._event) {
      this._event = (listener, thisArgs) => {
        if (!this._callbacks) {
          this._callbacks = new CallbackList();
        }
        if (this._options && this._options.onFirstListenerAdd && this._callbacks.isEmpty()) {
          this._options.onFirstListenerAdd(this);
        }
        this._callbacks.add(listener, thisArgs);
        const result = {
          dispose: () => {
            result.dispose = _Emitter._noop;
            if (!this._disposed) {
              this._callbacks.remove(listener, thisArgs);
              result.dispose = _Emitter._noop;
              if (this._options && this._options.onLastListenerRemove && this._callbacks.isEmpty()) {
                this._options.onLastListenerRemove(this);
              }
            }
          }
        };
        return result;
      };
    }
    return this._event;
  }
  /**
   * Fires the event with the specified payload.
   * @param event The event payload.
   */
  fire(event) {
    if (this._callbacks) {
      this._callbacks.invoke(event);
    }
  }
};
__publicField(_Emitter, "_noop", function() {
});
var Emitter = _Emitter;

// src/common/message.ts
var Message = Symbol.for("Message");

// src/common/command.interface.ts
var CommandService = Symbol.for("CommandService");

// src/common/command.ts
var CommandContribution = Symbol.for("CommandContribution");
var CommandRegistry = class {
  /**
   * Creates an instance of CommandRegistry.
   * @param _message The message service used for displaying error messages.
   * @param _contributionProvider The contribution provider used for retrieving command contributions.
   */
  constructor(_message, _contributionProvider) {
    this._message = _message;
    this._contributionProvider = _contributionProvider;
    /**
     * The dictionary of registered commands.
     */
    __publicField(this, "_commands", {});
    /**
     * The dictionary of command handlers.
     */
    __publicField(this, "_handlers", {});
    __publicField(this, "onCommandsChangedEmitter", new Emitter());
    __publicField(this, "onCommandsChanged", this.onCommandsChangedEmitter.event);
    __publicField(this, "fireDidChange", () => {
      setTimeout(() => {
        this.doFireDidChange();
      }, 0);
    });
  }
  /**
   * Initializes the command registry by registering commands from contributions.
   */
  onStart() {
    this._contributionProvider.getContributions().forEach((contribution) => {
      contribution.registerCommands(this);
    });
  }
  /**
   * Registers a command with an optional command handler.
   * @param command The command to register.
   * @param handler The command handler to associate with the command.
   * @returns A disposable object that can be used to unregister the command and handler.
   */
  registerCommand(command, handler) {
    const commandId = command.id;
    if (this._commands[commandId]) {
      console.warn(`Command ${commandId} already registered.`);
      return Disposable.NULL;
    }
    let disposables = [];
    disposables.push(this.doRegisterCommand(command));
    if (handler) {
      disposables.push(this.registerHandler(commandId, handler));
    }
    return {
      dispose: () => {
        disposables.forEach((d) => d.dispose());
      }
    };
  }
  /**
   * Registers a command in the command registry.
   * @param command The command to register.
   * @returns A disposable object that can be used to unregister the command.
   */
  doRegisterCommand(command) {
    this._commands[command.id] = command;
    return {
      dispose: () => {
        delete this._commands[command.id];
      }
    };
  }
  /**
   * Registers a command handler for a specific command.
   * @param commandId The ID of the command.
   * @param handler The command handler to register.
   * @returns A disposable object that can be used to unregister the command handler.
   */
  registerHandler(commandId, handler) {
    let handlers = this._handlers[commandId];
    if (!handlers) {
      this._handlers[commandId] = handlers = [];
    }
    handlers.unshift(handler);
    this.fireDidChange();
    return {
      dispose: () => {
        const idx = handlers.indexOf(handler);
        if (idx >= 0) {
          handlers.splice(idx, 1);
          this.fireDidChange();
        }
      }
    };
  }
  doFireDidChange() {
    this.onCommandsChangedEmitter.fire();
  }
  /**
   * Retrieves a command by its ID.
   * @param id The ID of the command.
   * @returns The command with the specified ID, or undefined if not found.
   */
  getCommand(id) {
    return this._commands[id];
  }
  /**
   * Executes a command with the specified ID and arguments.
   * @param commandId The ID of the command to execute.
   * @param args The arguments to pass to the command handler.
   * @returns A promise that resolves to the result of the command execution.
   * @throws An error if the command cannot be executed due to the absence of active handlers.
   */
  async executeCommand(commandId, ...args) {
    const handler = this.getActiveHandler(commandId, ...args);
    if (handler) {
      const result = await handler.execute(...args);
      return result;
    }
    this._message.error({
      message: `The command '${commandId}' cannot be executed. There are no active handlers available for the command.`
    });
    throw Object.assign(new Error(`The command '${commandId}' cannot be executed. There are no active handlers available for the command.`), { code: "NO_ACTIVE_HANDLER" });
  }
  /**
   * Retrieves the active command handler for the specified command ID and arguments.
   * @param commandId The ID of the command.
   * @param args The arguments to pass to the command handler.
   * @returns The active command handler, or undefined if not found.
   */
  getActiveHandler(commandId, ...args) {
    const handlers = this._handlers[commandId];
    if (!handlers) {
      return void 0;
    }
    for (const handler of handlers) {
      if (handler.isEnabled && !handler.isEnabled(...args)) {
        continue;
      }
      return handler;
    }
    return void 0;
  }
  getAllCommands() {
    return Object.values(this._commands).map((command) => {
      return {
        ...command,
        handlers: this._handlers[command.id] || []
      };
    });
  }
};
CommandRegistry = __decorateClass([
  (0, inversify_exports.injectable)(),
  __decorateParam(0, (0, inversify_exports.inject)(Message)),
  __decorateParam(1, (0, inversify_exports.inject)(ContributionProvider)),
  __decorateParam(1, (0, inversify_exports.named)(CommandContribution))
], CommandRegistry);

// src/common/logger.ts
var Logger = Symbol.for("Logger");

// src/common/error-handler-contribution.ts
var ErrorHandlerContribution = Symbol.for("ErrorHandlerContribution");
var ErrorHandlerRegistry = Symbol.for("ErrorHandlerRegistry");
var ErrorHandlerRegistryImpl = class {
  /**
   * Creates an instance of ErrorHandlerRegistryImpl.
   * @param _contributionProvider The contribution provider for error handler contributions.
   * @param _logger The logger instance for logging warnings.
   */
  constructor(_contributionProvider, _logger) {
    this._contributionProvider = _contributionProvider;
    this._logger = _logger;
    __publicField(this, "_handlers", []);
  }
  /**
   * Called when the registry starts.
   * Iterates through the contributions and registers the handlers.
   */
  onStart() {
    this._contributionProvider.getContributions().forEach((contribution) => {
      contribution.registerHandler(this);
    });
  }
  /**
   * Registers a handler with the registry.
   * @param handler The handler to be registered.
   * @returns A disposable object that can be used to unregister the handler.
   */
  register(handler) {
    if (this._handlers.indexOf(handler) === -1) {
      this._handlers.push(handler);
    } else {
      this._logger.warn("The handler has been added", handler);
    }
    return {
      dispose: () => {
        const index = this._handlers.indexOf(handler);
        if (index !== -1) {
          this._handlers.splice(index, 1);
        }
      }
    };
  }
  /**
   * Gets the list of registered handlers.
   * @returns An array of registered handlers.
   */
  get handlers() {
    return [...this._handlers];
  }
};
ErrorHandlerRegistryImpl = __decorateClass([
  (0, inversify_exports.injectable)(),
  __decorateParam(0, (0, inversify_exports.inject)(ContributionProvider)),
  __decorateParam(0, (0, inversify_exports.named)(ErrorHandlerContribution)),
  __decorateParam(1, (0, inversify_exports.inject)(Logger))
], ErrorHandlerRegistryImpl);

// src/utils/event-listener.ts
function createDisposableListener(target, type, listener, options) {
  target.addEventListener(type, listener, options);
  return {
    dispose() {
      target.removeEventListener(type, listener, options);
    }
  };
}

// src/common/error-handler.ts
var ErrorHandler = Symbol.for("ErrorHandler");
var ErrorHandlerImpl = class {
  constructor(_logger, _errorHandlerRegistry) {
    this._logger = _logger;
    this._errorHandlerRegistry = _errorHandlerRegistry;
    __publicField(this, "_disposes", []);
  }
  /**
   * Starts the error handling process by attaching event listeners.
   */
  onStart() {
    this._disposes.push(createDisposableListener(window, "error", this._handleError.bind(this)));
    this._disposes.push(createDisposableListener(window, "unhandledrejection", this._handleRejectionError.bind(this)));
  }
  /**
   * Executes the registered error handlers for the given error.
   * @param error - The error to be handled.
   * @returns True if any handler successfully handles the error, false otherwise.
   */
  _executeHandlers(error) {
    for (let handler of this._errorHandlerRegistry.handlers) {
      let bool = false;
      try {
        bool = handler(error);
      } catch (e) {
        this._logger.error("Error when executing handler", e, handler);
      }
      if (bool) {
        return true;
      }
    }
    return false;
  }
  /**
   * Event handler for the 'error' event.
   * Prevents the default behavior and stops the event propagation.
   * @param event - The error event.
   */
  _handleError(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this._executeHandlers(event.error);
  }
  /**
   * Event handler for the 'unhandledrejection' event.
   * Prevents the default behavior and stops the event propagation.
   * @param event - The unhandled rejection event.
   */
  _handleRejectionError(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this._executeHandlers(event.reason);
  }
  /**
   * Disposes the error handler by disposing all attached event listeners.
   */
  dispose() {
    this._disposes.forEach((disposable) => {
      disposable.dispose();
    });
  }
};
ErrorHandlerImpl = __decorateClass([
  (0, inversify_exports.injectable)(),
  __decorateParam(0, (0, inversify_exports.inject)(Logger)),
  __decorateParam(1, (0, inversify_exports.inject)(ErrorHandlerRegistry))
], ErrorHandlerImpl);

// src/common/http-channel.ts
import { RequestChannel } from "@patsnap/common-ps-http";
var PsHttp$ = Symbol.for("psHttp$");
var PsHttpChannel = Symbol.for("PsHttpChannel");
var PsHttpChannelImpl = class {
  constructor(httpChannelClient) {
    this.httpChannelClient = httpChannelClient;
    __publicField(this, "channelMap", /* @__PURE__ */ new Map());
  }
  /**
   * Retrieves the request channel associated with the specified symbol ID.
   * If the channel does not exist, a new channel is created and added to the channel map.
   * @param symbolId - The symbol ID used to identify the request channel.
   * @returns The request channel associated with the symbol ID.
   */
  getChannel(symbolId) {
    let channel = this.channelMap.get(symbolId);
    if (channel) {
      return channel;
    }
    channel = new RequestChannel(this.httpChannelClient);
    this.channelMap.set(symbolId, channel);
    return channel;
  }
};
PsHttpChannelImpl = __decorateClass([
  (0, inversify_exports.injectable)(),
  __decorateParam(0, (0, inversify_exports.inject)(PsHttp$))
], PsHttpChannelImpl);

// src/common/http-error-handler-contribution.ts
var HttpErrorHandlerContribution = Symbol.for("HttpErrorHandlerContribution");
var HttpErrorHandlerRegistry = Symbol.for("HttpErrorHandlerRegistry");
var HttpErrorHandlerRegistryImpl = class {
  constructor(_contributionProvider) {
    this._contributionProvider = _contributionProvider;
    __publicField(this, "_httpOkHandlers", []);
    __publicField(this, "_httpErrorHandlers", []);
  }
  onStart() {
    this._contributionProvider.getContributions().forEach((contribution) => {
      contribution.registerHandler(this);
    });
  }
  register(type, handler) {
    if (type === "http200") {
      this._httpOkHandlers.push(handler);
    } else if (type === "!http200") {
      this._httpErrorHandlers.push(handler);
    } else {
      throw new Error(`Unknown HttpErrorHandlerType ${type}, only support 'http200' and '!http200'`);
    }
  }
  getHttpOkHandlers() {
    return [...this._httpOkHandlers];
  }
  getHttpErrorHandlers() {
    return [...this._httpErrorHandlers];
  }
};
HttpErrorHandlerRegistryImpl = __decorateClass([
  (0, inversify_exports.injectable)(),
  __decorateParam(0, (0, inversify_exports.inject)(ContributionProvider)),
  __decorateParam(0, (0, inversify_exports.named)(HttpErrorHandlerContribution))
], HttpErrorHandlerRegistryImpl);

// src/common/lazy-link.ts
var LazyLinkService = Symbol.for("LazyLinkService");
var LazyLinkContribution = Symbol.for("LazyLinkContribution");
var LazyLinkRegistry = class {
  constructor(_contributionProvider) {
    this._contributionProvider = _contributionProvider;
    __publicField(this, "_links", {});
  }
  onStart() {
    this._contributionProvider.getContributions().forEach((contribution) => {
      contribution.registerLinks(this);
    });
  }
  registerLink(link) {
    const id = link.field;
    this._links[id] = link;
  }
  getLink(field) {
    if (!field) return;
    return this._links[field];
  }
};
LazyLinkRegistry = __decorateClass([
  (0, inversify_exports.injectable)(),
  __decorateParam(0, (0, inversify_exports.inject)(ContributionProvider)),
  __decorateParam(0, (0, inversify_exports.named)(LazyLinkContribution))
], LazyLinkRegistry);

// src/common/model.ts
import _2 from "lodash";
var AbstractModel = class {
  constructor() {
    /**
     * Emitter for states change events.
     */
    __publicField(this, "_onStatesChangeEmitter", new Emitter());
    /**
     * Event that fires when the states change.
     */
    __publicField(this, "onStatesChange", this._onStatesChangeEmitter.event);
  }
  /**
   * Clones the model data.
   * @returns A deep clone of the model data.
   */
  clone(data) {
    return _2.cloneDeep(data);
  }
  /**
   * Gets the model data.
   * @returns The model data.
   */
  get modelData() {
    return this.clone(this._modelData);
  }
  /**
   * Emits the model data change event.
   */
  _emitModelDataChange() {
    this._onStatesChangeEmitter.fire(this.modelData);
  }
  /**
   * Updates the model data.
   * @param updater - A function that takes the current model data and returns the updated model data.
   */
  update(updater) {
    const newData = updater(this.modelData);
    this._update(newData);
    this._emitModelDataChange();
  }
  /**
   * Updates the model data.
   * @param value - The updated model data.
   */
  _update(value) {
    this._modelData = value;
  }
};
AbstractModel = __decorateClass([
  (0, inversify_exports.injectable)()
], AbstractModel);

// src/common/ps-http.ts
import _3 from "lodash";
var PsHttp = Symbol.for("psHttp");
function isPatSnapErrorResponseData(data) {
  return data.status === false;
}
var PsHttpError = class extends Error {
  constructor(message, options) {
    super(message, options);
    __publicField(this, "type", "PsHttpError");
    /**
     * The cause of the error.
     * @description The error response data from the PatSnap Core data API.
     */
    __publicField(this, "cause");
    this.cause = options == null ? void 0 : options.cause;
  }
};
function isPsHttpError(error) {
  if (!error) {
    return false;
  }
  return error && error.type === "PsHttpError";
}
var PsHttpService = class {
  constructor(httpClient, httpChannelClient) {
    this.httpClient = httpClient;
    this.httpChannelClient = httpChannelClient;
  }
  request(config) {
    config.headers = _3.merge({}, this.options.headers, config.headers);
    config.baseURL = config.baseURL || this.options.baseURL;
    return this.httpClient(config).then((res) => {
      const data = res.data;
      if (isPatSnapErrorResponseData(data)) {
        const error = new PsHttpError(data.data.error_message, {
          cause: data
        });
        throw error;
      }
      return res.data;
    }).catch((error) => {
      throw error;
    });
  }
  channel(symbolId, config) {
    config.headers = _3.merge({}, this.options.headers, config.headers);
    config.baseURL = config.baseURL || this.options.baseURL;
    const channel = this.httpChannelClient.getChannel(symbolId);
    return channel.requestAsPromise(config).then((data) => {
      if (isPatSnapErrorResponseData(data)) {
        const error = new PsHttpError(data.data.error_message, {
          cause: data
        });
        throw error;
      }
      return data;
    }).catch((error) => {
      throw error;
    });
  }
  get(config) {
    config = _3.merge({
      method: "get"
    }, config);
    return this.request(config);
  }
  post(config) {
    config = _3.merge({
      method: "post"
    }, config);
    return this.request(config);
  }
  put(config) {
    config = _3.merge({
      method: "put"
    }, config);
    return this.request(config);
  }
  patch(config) {
    config = _3.merge({
      method: "patch"
    }, config);
    return this.request(config);
  }
  delete(config) {
    config = _3.merge({
      method: "delete"
    }, config);
    return this.request(config);
  }
  postForm(config) {
    config = _3.merge({
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    }, config);
    return this.request(config);
  }
  postMultipartForm(config) {
    config = _3.merge({
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }, config);
    return this.request(config);
  }
  patchMultipartForm(config) {
    config = _3.merge({
      method: "patch",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }, config);
    return this.request(config);
  }
};
PsHttpService = __decorateClass([
  (0, inversify_exports.injectable)(),
  __decorateParam(0, (0, inversify_exports.inject)(PsHttp)),
  __decorateParam(1, (0, inversify_exports.inject)(PsHttpChannel))
], PsHttpService);

// src/ioc/inject.ts
var _container;
function setContainer(container) {
  _container = container;
}
function getContainer() {
  if (!_container) throw new Error("Container is not setup");
  return _container;
}
function clearContainer() {
  _container = void 0;
}
function bindContainer(fn) {
  return (...args) => fn(getContainer(), ...args);
}
function injectService(identifier) {
  const container = getContainer();
  return container.get(identifier);
}
function injectNamedService(identifier, name) {
  const container = getContainer();
  return container.getNamed(identifier, name);
}

// src/utils/deferred.ts
function create() {
  const deferred = /* @__PURE__ */ Object.create({});
  deferred.promise = new Promise(function(resolve, reject) {
    deferred.resolve = (...rest) => {
      deferred.resolved = true;
      deferred.completed = true;
      resolve(...rest);
    };
    deferred.reject = (...rest) => {
      deferred.rejected = true;
      deferred.completed = true;
      reject(...rest);
    };
  });
  return deferred;
}

// src/services/dialog-manager.ts
var DialogManager = Symbol.for("DialogManager");

// src/services/abstract-dialog-service.ts
var RouteGuard = Symbol.for("RouteGuard");
var AbstractDialogInputService = class {
  constructor() {
    __publicField(this, "_dialogManager");
    __publicField(this, "routeGuard");
    __publicField(this, "_submitCallback", (data, next) => {
      next(true);
    });
    __publicField(this, "_cancelCallback", () => {
    });
    __publicField(this, "_deferred");
    __publicField(this, "_disposes", []);
    __publicField(this, "_routeGuardDispose", () => {
    });
  }
  /**
   * Registers a callback to be called when the cancel button is clicked.
   * @param callback The callback function to be called when the cancel button is clicked.
   */
  onCancel(callback) {
    this._cancelCallback = callback;
  }
  /**
   * 打开对话框
   * @param DialogOptions 
   * @returns 
   */
  open(dialogOptions) {
    this._deferred = create();
    const props = {
      ...dialogOptions,
      callbacks: {
        submit: (data) => {
          return this._invokeSubmitCallback(data);
        },
        abort: () => {
          return this._invokeCancelCallback();
        }
      },
      onSubmit: (data) => {
        return this._invokeSubmitCallback(data);
      },
      onCancel: () => {
        return this._invokeCancelCallback();
      }
    };
    this._dialogManager.update(this.component, props);
    this._dialogManager.toggleOpenState(this.component, true);
    this._setRouteGuard();
    return this._deferred.promise;
  }
  /**
   * 关闭对话框
   */
  close() {
    this._invokeCancelCallback();
  }
  /**
   * Registers a callback to be called  when the submit button is clicked.
   * @param callback The callback function to be called when the submit button is clicked.
   */
  onSubmit(callback) {
    this._submitCallback = callback;
  }
  /**
   * @deprecated Use `onSubmit` instead.
   */
  onReceived(callback) {
    this.onSubmit(callback);
  }
  /**
   * @deprecated Use `onCancel` instead.
   */
  onAborted(callback) {
    this.onCancel(callback);
  }
  /**
   * @deprecated Use `open` instead.
   */
  request(dialogOptions) {
    return this.open(dialogOptions);
  }
  /**
   * @deprecated Use `close` instead.
   */
  abort() {
    this.close();
  }
  /**
   * 执行通过 onSubmit 注册的回调函数，并关闭对话框
   * @param data 
   * @returns 
   */
  async _invokeSubmitCallback(data) {
    await this._submitCallback(data, (bool = true) => {
      if (bool) {
        this._closeDialog();
        this._deferred.resolve(data);
      }
    });
    return this._deferred.promise;
  }
  /**
   * 执行通过 onCancel 注册的回调函数，并关闭对话框
   */
  _invokeCancelCallback() {
    this._cancelCallback();
    this._closeDialog();
    this._dispose();
    this._deferred.promise.catch(() => {
    });
    this._deferred.reject();
    return;
  }
  _dispose() {
    this._disposes.forEach((disposable) => {
      disposable.dispose();
    });
    this._disposes.length = 0;
  }
  _setRouteGuard() {
    var _a;
    this._routeGuardDispose();
    this._routeGuardDispose = ((_a = this.routeGuard) == null ? void 0 : _a.beforeEach((to, from, next) => {
      const has = this._dialogManager.hasOpenDialog();
      if (has) {
        next(false);
      } else {
        next();
      }
    })) || (() => {
    });
    this._disposes.push({ dispose: () => {
      this._routeGuardDispose();
    } });
  }
  _closeDialog() {
    this._dialogManager.toggleOpenState(this.component, false);
    this._dialogManager.unregister(this.component);
  }
};
__decorateClass([
  (0, inversify_exports.inject)(DialogManager)
], AbstractDialogInputService.prototype, "_dialogManager", 2);
__decorateClass([
  (0, inversify_exports.optional)(),
  (0, inversify_exports.inject)(RouteGuard)
], AbstractDialogInputService.prototype, "routeGuard", 2);
AbstractDialogInputService = __decorateClass([
  (0, inversify_exports.injectable)()
], AbstractDialogInputService);
function defineProperty(target, propertyKey, instance) {
  Object.defineProperty(target, propertyKey, {
    get() {
      return instance;
    }
  });
}
function manualInject(target, propertyKey, bindId) {
  Object.defineProperty(target, propertyKey, {
    get() {
      return injectService(bindId);
    }
  });
}
function createDialogInstance(component) {
  function create2() {
    return class A extends AbstractDialogInputService {
      constructor() {
        super(...arguments);
        __publicField(this, "component", component);
      }
    };
  }
  const instance = new (create2())();
  manualInject(instance, "_dialogManager", DialogManager);
  manualInject(instance, "routeGuard", RouteGuard);
  return instance;
}
function createDialog(component) {
  return () => createDialogInstance(component);
}
var dialogMetadataKey = Symbol("dialog");
function dialog(value) {
  function attributeDecorator(target, propertyKey) {
    let instance = Reflect.getOwnMetadata(dialogMetadataKey, target, propertyKey);
    if (!instance) {
      instance = createDialogInstance(value);
      Reflect.defineMetadata(dialogMetadataKey, instance, target, propertyKey);
    }
    defineProperty(target, propertyKey, instance);
  }
  ;
  return attributeDecorator;
}

// src/services/cookie-service.ts
var CookieService = Symbol.for("CookieService");

// src/services/location-service.ts
var LocationService = Symbol.for("LocationService");
var LocationServiceImpl = class {
  /**
   * Gets the host of the current location.
   * @returns The host of the current location.
   */
  get host() {
    return window.location.host;
  }
  /**
   * Gets the pathname of the current location.
   * @returns The pathname of the current location.
   */
  get pathname() {
    return window.location.pathname;
  }
  /**
   * Gets the search string of the current location.
   * @returns The search string of the current location.
   */
  get search() {
    return window.location.search;
  }
};
LocationServiceImpl = __decorateClass([
  (0, inversify_exports.injectable)()
], LocationServiceImpl);

// src/services/language-service.ts
var LanguageService = Symbol.for("LanguageService");
var LanguageServiceImpl = class {
  constructor(_cookieService, _locationService) {
    this._cookieService = _cookieService;
    this._locationService = _locationService;
    __publicField(this, "_locale");
  }
  /**
   * Retrieves the current language setting.
   * @returns The current language.
   */
  getCurrentLanguage() {
    if (!this._locale) {
      let locale;
      const data = this._cookieService.match(LanguageServiceImpl.PATTERN) || [];
      locale = data[1];
      if (locale && ["cn", "tw", "en", "jp"].indexOf(locale) === -1) {
        locale = void 0;
      }
      if (!locale) {
        const host = this._locationService.host;
        if (host.indexOf(".patsnap.") > -1) {
          locale = "en";
        } else if (host.indexOf(".zhihuiya.") > -1) {
          locale = "cn";
        }
      }
      this._locale = locale || "en";
    }
    return this._locale;
  }
  /**
   * Checks if the current language is Chinese.
   * @returns True if the current language is Chinese, false otherwise.
   */
  isZh() {
    const locale = this.getCurrentLanguage();
    return locale === "cn" || locale === "tw";
  }
};
__publicField(LanguageServiceImpl, "PATTERN", /---uniform-setting-locale=(\w+)/);
LanguageServiceImpl = __decorateClass([
  (0, inversify_exports.injectable)(),
  __decorateParam(0, (0, inversify_exports.inject)(CookieService)),
  __decorateParam(1, (0, inversify_exports.inject)(LocationService))
], LanguageServiceImpl);

// src/services/open-service.ts
var OpenService = Symbol.for("OpenService");
var OpenServiceImpl = class {
  constructor() {
  }
  /**
   * Opens the specified URL in a new window or tab.
   * @param url The URL to open.
   * @param data Optional configuration for opening the URL.
   */
  open(url, data = {}) {
    var _a;
    window.open(url, (_a = data.target) != null ? _a : "_blank", data.noopener ? "noopener" : "");
  }
  /**
   * Opens the specified URL asynchronously in a new window or tab.
   * @param url The URL to open.
   * @param data Optional configuration for opening the URL.
   * @returns A promise that resolves when the URL is successfully opened.
   */
  openAsync(url, data = {}) {
    return new Promise((resolve, reject) => {
      const tab = window.open();
      try {
        if (data.noopener) {
          tab.opener = null;
        }
        tab.location = url;
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
};
OpenServiceImpl = __decorateClass([
  (0, inversify_exports.injectable)()
], OpenServiceImpl);

// src/utils/timeout.ts
function createDisposableTimeout(callback, delay) {
  const id = setTimeout(callback, delay);
  return {
    dispose() {
      clearTimeout(id);
    }
  };
}
export {
  AbstractDialogInputService,
  AbstractModel,
  Bindable,
  CommandContribution,
  CommandRegistry,
  CommandService,
  ContributionProvider,
  CookieService,
  DialogManager,
  Disposable,
  Emitter,
  ErrorHandler,
  ErrorHandlerContribution,
  ErrorHandlerImpl,
  ErrorHandlerRegistry,
  ErrorHandlerRegistryImpl,
  HttpErrorHandlerContribution,
  HttpErrorHandlerRegistry,
  HttpErrorHandlerRegistryImpl,
  LanguageService,
  LanguageServiceImpl,
  LazyLinkContribution,
  LazyLinkRegistry,
  LazyLinkService,
  LocationService,
  LocationServiceImpl,
  Logger,
  Message,
  OpenService,
  OpenServiceImpl,
  PsHttp,
  PsHttp$,
  PsHttpChannel,
  PsHttpChannelImpl,
  PsHttpError,
  PsHttpService,
  RouteGuard,
  bindContainer,
  bindContributionProvider,
  clearContainer,
  create,
  createDialog,
  createDialogInstance,
  createDisposableListener,
  createDisposableTimeout,
  dialog,
  disposableTimeout,
  getContainer,
  injectNamedService,
  injectService,
  isObject,
  isPatSnapErrorResponseData,
  isPsHttpError,
  setContainer
};
//# sourceMappingURL=index.js.map
